import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { SheetModal } from '@/components/SheetModal';
import { BsFillQuestionCircleFill } from 'react-icons/bs';
import { ROISlideOutContent } from './LearnMoreSlideOutContent';

interface ROIGuidanceProps {
  className?: string;
  buttonSize?: 'default' | 'sm' | 'lg' | 'icon';
  disableAbsolutePosition?: boolean;
  policyType?: FundingPolicyType;
}

export function ROIGuidance({
  className = '',
  buttonSize = 'icon',
  disableAbsolutePosition = false,
  policyType,
}: ROIGuidanceProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={disableAbsolutePosition ? '' : 'flex justify-end'}>
      <Button
        onClick={() => setIsOpen(true)}
        variant="ghost"
        size={buttonSize}
        className={`h-auto p-0 hover:bg-transparent ${className}`}
      >
        <BsFillQuestionCircleFill
          className="h-5 w-5 pb-1 text-gray-500 hover:text-gray-700"
          aria-hidden="true"
        />
      </Button>

      <SheetModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        title="Waterlily AI"
        subTitle=""
        modal={true}
        className="min-w-[95%] sm:min-w-[90%] md:min-w-[600px] lg:min-w-[650px]"
      >
        <div className="flex min-h-full flex-1 flex-col overflow-auto text-black">
          <div className="flex flex-1 flex-col py-4">
            <ROISlideOutContent policyType={policyType} />
          </div>
        </div>
      </SheetModal>
    </div>
  );
}
